import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface RuntimeConfig {
    sosUrl: string;
    intercomAppId: string;
    envName: string;
    sentryDebug: boolean;
    smartIdUserProfileUrl: string;
}

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
    private config: RuntimeConfig = {
        sosUrl: '',
        intercomAppId: '',
        envName: 'prod',
        sentryDebug: false,
        smartIdUserProfileUrl: '',
    };

    constructor(private http: HttpClient) {}

    load(): Promise<void> {
        return this.http.get<RuntimeConfig>('/api/config').toPromise().then(
            (config) => { this.config = config; }
        );
    }

    get sosUrl(): string { return this.config.sosUrl; }
    get intercomAppId(): string { return this.config.intercomAppId; }
    get envName(): string { return this.config.envName; }
    get sentryDebug(): boolean { return this.config.sentryDebug; }
    get smartIdUserProfileUrl(): string { return this.config.smartIdUserProfileUrl; }
}
